/* global jQuery */
/* Site Info Banner Widget */

(function ($) {
  // Data service for the widget
  function widgetDataService() {
    this.getWidgetData = function (
      servicePath,
      widgetModuleItemID,
      successCallback,
      errorCallback,
    ) {
      $.ajax({
        type: 'POST',
        url: servicePath,
        data: "{'widgetModuleItemID':" + widgetModuleItemID + '}',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: successCallback,
        error: errorCallback,
      });
    };
  }

  // Global variables for the widget function
  var widgetData = null;
  var widgetContainer = null;
  var eventNameContentContainer = null;
  var eventDatesContentContainer = null;
  var numberOfDays;
  var previouslyViewedDate = true;
  var customConnector = null;
  var eventLength = null;
  var afterMessage = '';
  var siteInfoBannerLoaded = function () {};

  // Constructor for the widget
  $.fn.SiteInfoBanner = function (options) {
    var opts = $.extend({}, $.fn.SiteInfoBanner.defaultOptions, options);

    widgetContainer = this;

    eventNameContentContainer = widgetContainer.find('#eventName');
    eventDatesContentContainer = widgetContainer.find('#eventDates');
    previouslyViewedDate = opts.previouslyViewedDate;

    var widgetDataAdapter = new widgetDataService();

    widgetDataAdapter.getWidgetData(
      opts.scriptPath,
      opts.currentWidgetModuleItemID,
      getWidgetDataSuccess,
      getWidgetDataError,
    );

    customConnector = opts.customConnector;
    siteInfoBannerLoaded = opts.siteInfoBannerLoaded;
  };

  // Default options
  $.fn.SiteInfoBanner.defaultOptions = {
    scriptPath: 'services/eventsservice.asmx',
    currentWidgetModuleItemID: 0,
    previouslyViewedDate: true,
    customConnector: null,
    siteInfoBannerLoaded: function () {
      var daysContainer = $('#countdown-timer-days');
      var hoursContainer = $('#countdown-timer-hours');
      var minContainer = $('#countdown-timer-minutes');
      var secContainer = $('#countdown-timer-seconds');

      if (widgetData.NumberOfDays >= 1) {
        var daysUntilEvent = widgetData.NumberOfDays;

        function formatDate(date) {
          var monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ];
          var day = date.getDate();
          var monthIndex = date.getMonth();
          var year = date.getFullYear();
          return day + ' ' + monthNames[monthIndex] + ' ' + year;
        }

        var currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + daysUntilEvent);
        var coundownToThisDate = formatDate(currentDate);
        var countDownDate = new Date(coundownToThisDate).getTime();

        var x = setInterval(function () {
          var now = new Date().getTime();
          var distance = countDownDate - now;

          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          daysContainer.html('<span>' + days + '</span>');
          hoursContainer.html('<span>' + hours + '</span>');
          minContainer.html('<span>' + minutes + '</span>');
          secContainer.html('<span>' + seconds + '</span>');

          if (distance < 0) {
            clearInterval(x);
            console.log('EXPIRED');
          }
        }, 1000);
      } else {
        daysContainer.text('0');
        hoursContainer.text('0');
        minContainer.text('0');
        secContainer.text('0');
      }
    },
  };

  // Success callback
  var getWidgetDataSuccess = function (data) {
    widgetData = data.d;
    initialize();
  };

  // Error callback
  var getWidgetDataError = function (data) {
    console.log(
      'Site Info Banner failed to load',
      '\n' + 'Status: ' + data.status + ' ' + data.statusText,
      '\n' + data.responseText,
    );
  };

  // UI initialization
  function initialize() {
    if (!widgetData.Enabled) return;

    if (widgetData.ShowAfterEventMessage) {
      afterMessage = widgetData.AfterEventMessage;
    }

    eventLength = widgetData.EventLength;
    numberOfDays = widgetData.NumberOfDays;

    var m = numberOfDays <= 0 ? numberOfDays + eventLength : 0;
    var i = numberOfDays + 50;

    if (numberOfDays > 0) {
      var until = customConnector != null ? customConnector : 'until';
      if (widgetData.LoadedFromCountdowns) until = '';

      eventDatesContentContainer.text(widgetData.DateString);

      if (!previouslyViewedDate) {
        setInterval(function () {
          if (i >= numberOfDays) {
            var dayWord = i === 1 ? 'day' : 'days';
            eventNameContentContainer.html(
              '<span class="countdownDays">' +
                i +
                ' <span class="dayWord">' +
                dayWord +
                '</span></span> ' +
                until +
                ' ' +
                widgetData.EventName,
            );
            i--;
          }
        }, 50);
      } else {
        var dayWord = numberOfDays === 1 ? 'day' : 'days';
        eventNameContentContainer.html(
          '<span class="countdownDays">' +
            numberOfDays +
            ' <span class="dayWord">' +
            dayWord +
            '</span></span> ' +
            until +
            ' ' +
            widgetData.EventName,
        );
      }
    } else if (m < 0) {
      if (widgetData.EventName != null) {
        eventDatesContentContainer.text(widgetData.EventName);
      }

      eventNameContentContainer.html('<span class="countdownDays">' + afterMessage + '</span>');

      if (afterMessage === '') {
        $('#widgetBanner').addClass('noThankYouMessage');
        $('body').addClass('siteInfoBannerWidgetNoThankYouMessage');
      }

      $('#widgetBanner').addClass('datePast');
      $('body').addClass('siteInfoBannerWidgetDateIsPast');
    } else {
      $('#siteInfoBannerWidget').css('display', 'block');
      eventDatesContentContainer.text(widgetData.DateString);
      eventNameContentContainer.css('display', 'none');
      $('#widgetBanner').addClass('eventHappening');
      $('body').addClass('siteInfoBannerWidgetEventHappening');
    }

    siteInfoBannerLoaded(widgetData);

    var infoBannerCountdownContent = $('.countdownDays').html();
    var infoBannerDatesContent = $('#eventDates').html();
    if (infoBannerCountdownContent === '' && infoBannerDatesContent === '') {
      $('body').addClass('siteInfoBannerOff');
    } else {
      $('body').addClass('siteInfoBannerOn');
    }

    widgetContainer.show();
    $('#countdown-timer').css('opacity', '1');
  }
})(jQuery);
